module.exports = __webpack_public_path__ + "img/35ad056477647ed3d2db854f9b655f95.34acda52.webp";